module.exports = __webpack_public_path__ + "static/img/9.1b4fca3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/9.png
// module id = RTEC
// module chunks = 0